import { render, staticRenderFns } from "./ObservationReadMore.vue?vue&type=template&id=6ff17b1e&scoped=true"
import script from "./ObservationReadMore.vue?vue&type=script&lang=js"
export * from "./ObservationReadMore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ff17b1e",
  null
  
)

export default component.exports